const sectionCardBasicCss = `
[data-type='section-card-basic'] .card-basic-wrapper {
  background-color: var(--background-color, #14a16c);
  color: var(--text-color, #ffffff);
}

[data-type='section-card-basic'] .card-basic-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-basic'] .card-basic-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-basic'] .card-basic-wrapper[data-image-position='right'] .card-basic-content {
  flex-direction: row-reverse;
}

[data-type='section-card-basic'] .card-basic-wrapper[data-image-position='left'] .card-basic-content {
  flex-direction: row;
}

[data-type='section-card-basic'] .card-basic-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
}

[data-type='section-card-basic'] .card-basic-image {
  width: var(--image-width, 100%);
  height: auto;
}

[data-type='section-card-basic'] .card-basic-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-basic'] .card-basic-content-text {
  flex: 1;
}

[data-type='section-card-basic'] .card-basic-content-text h1,
[data-type='section-card-basic'] .card-basic-content-text h2,
[data-type='section-card-basic'] .card-basic-content-text h3 {
  font-size: 18px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-basic'] .card-basic-content-text h1:last-child,
[data-type='section-card-basic'] .card-basic-content-text h2:last-child,
[data-type='section-card-basic'] .card-basic-content-text h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-basic'] .card-basic-content-text p {
  font-size: 16px;
  margin: 0 0 4px 0 !important;
  line-height: normal;
}

[data-type='section-card-basic'] .card-basic-content-text p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-card-basic'] .card-basic-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-basic'] .card-basic-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-basic'] .card-basic-content {
    flex-direction: column !important;
  }

  [data-type='section-card-basic'] .card-basic-image {
    width: 60%;
  }

  [data-type='section-card-basic'] .card-basic-content-text h1,
  [data-type='section-card-basic'] .card-basic-content-text h2,
  [data-type='section-card-basic'] .card-basic-content-text h3 {
    font-size: 16px;
  }
}
`;
export default sectionCardBasicCss;
